import * as Sentry from "@sentry/browser";

/* eslint-disable no-console */
const sendError = err => {
  if (process.env.NODE_ENV === "production" && window.sendToSentry) {
    Sentry.captureException(err);
  } else {
    console.error(`Exception caught which will not be sent to Sentry:`);
    console.error(err);
  }
};

export default {
  sendError
};
